import React from 'react';
import globalGetPadding from '../../utils/getPadding';
import eCom365Logo from "../../../../static/e-com365_logo.png";
import { getResponsiveValue } from '../../utils/commonFun';

export function CustomImage({ style, props, formClientWidth }) {
    const isMobile = formClientWidth <= 480;
    const sectionStyle = {
        padding: globalGetPadding(style?.padding, isMobile),
        backgroundColor: style?.backgroundColor ?? undefined,
        textAlign: style?.textAlign ?? undefined,
    };

    const linkHref = props?.linkHref ?? null;
    const width = getResponsiveValue(props?.width, props?.mobileWidth, isMobile) ?? undefined;
    const height = getResponsiveValue(props?.height, props?.mobileHeight, isMobile) ?? undefined;

    const imageElement = (
        <img
            alt={props?.alt || ''}
            src={props?.url || eCom365Logo}
            width={width}
            height={height}
            style={{
                width: width ?? undefined,
                height: height ?? undefined,
                outline: 'none',
                border: 'none',
                textDecoration: 'none',
                verticalAlign: props?.contentAlignment ?? 'middle',
                display: 'inline-block',
                maxWidth: '100%',
            }}
        />
    );

    if (!linkHref) {
        return <div style={sectionStyle}>{imageElement}</div>;
    }

    return (
        <div style={sectionStyle}>
            <a href={linkHref} style={{ textDecoration: 'none' }} target="_blank">
                {imageElement}
            </a>
        </div>
    );
}
